// extracted by mini-css-extract-plugin
export default {"main-document":"EmptyViewer_main-document__-G0uK","empty-viewer":"EmptyViewer_empty-viewer__MBjbo"};